// extracted by mini-css-extract-plugin
module.exports = {"hiddenComponent":"SyncAvWidgets_hiddenComponent__k68Gx"};